import CreatePage from 'pages/group/create/page'
import DetailPage from 'pages/group/detail/page'
import GroupPage from 'pages/group/page'

export const groupRoutes = [
  { path: '/group', element: <GroupPage /> },
  { path: '/group/create', element: <CreatePage /> },
  { path: '/group/:id', element: <DetailPage /> },
]
